import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { RevealPackCardsDialogFromReward } from '@sorare/marketplace/src/components/commonCard/RevealPackCardsDialogFromReward';

import { AnyTaskClaimStory } from '#src/components/missions/AnyTaskClaimStory/index.tsx';
import { DropChallengePickerDialog } from '#src/components/missions/DailyTask/DropChallengeButton/DropChallengePickerDialog/index.tsx';

import type {
  TaskClaimedDialogs_anyRewardInterface,
  TaskClaimedDialogs_taskInterface,
} from './__generated__/index.graphql.ts';

type Props = {
  pickerDialogTask: TaskClaimedDialogs_taskInterface | null;
  onPickerDialogClose: () => void;
  revealPackCardsDialogReward: TaskClaimedDialogs_anyRewardInterface | null;
  onRevealPackCardsDialogClose: () => void;
  rewardDialogTask: TaskClaimedDialogs_taskInterface | null;
  onRewardDialogClose: () => void;
  onSuccess?: (task: TaskClaimedDialogs_taskInterface) => void;
};
export const TaskClaimedDialogs = ({
  pickerDialogTask,
  onPickerDialogClose,
  revealPackCardsDialogReward,
  onRevealPackCardsDialogClose,
  rewardDialogTask,
  onRewardDialogClose,
  onSuccess,
}: Props) => {
  return (
    <>
      {!!pickerDialogTask && isType(pickerDialogTask, 'DropChallengeTask') && (
        <DropChallengePickerDialog
          task={pickerDialogTask}
          onClose={onPickerDialogClose}
          onSuccess={() => onSuccess?.(pickerDialogTask)}
        />
      )}
      {!!revealPackCardsDialogReward && (
        <RevealPackCardsDialogFromReward
          open={!!revealPackCardsDialogReward}
          reward={revealPackCardsDialogReward}
          onClose={onRevealPackCardsDialogClose}
        />
      )}
      {!!rewardDialogTask && (
        <AnyTaskClaimStory
          open={!!rewardDialogTask}
          task={rewardDialogTask}
          onClose={() => {
            onRewardDialogClose?.();
          }}
        />
      )}
    </>
  );
};

TaskClaimedDialogs.fragments = {
  taskInterface: gql`
    fragment TaskClaimedDialogs_taskInterface on TaskInterface {
      id
      name
      ...DropChallengePickerDialog_dropChallengeTask
      ...AnyTaskClaimStory_taskInterface
    }
    ${DropChallengePickerDialog.fragments.dropChallengeTask}
    ${AnyTaskClaimStory.fragments.taskInterface}
  ` as TypedDocumentNode<TaskClaimedDialogs_taskInterface>,
  anyRewardInterface: gql`
    fragment TaskClaimedDialogs_anyRewardInterface on AnyRewardInterface {
      id
      ...RevealPackCardsDialogFromReward_anyRewardInterface
    }
    ${RevealPackCardsDialogFromReward.fragments.anyRewardInterface}
  ` as TypedDocumentNode<TaskClaimedDialogs_anyRewardInterface>,
};
